import { info, success, warn, error, clear, config } from './Notify';
export var Notify = {
    info: info,
    success: success,
    warn: warn,
    error: error,
    clear: clear,
    config: config,
};
export default Notify;
